// extracted by mini-css-extract-plugin
export var darkContainer = "darkMode-module--darkContainer--Gn0bY";
export var darkBg = "darkMode-module--darkBg--+ay8r";
export var darkModeText = "darkMode-module--darkModeText--ssS4-";